import { cancelled, put, call } from 'redux-saga/effects';
import { apiRequest } from './api';
import _ from 'lodash';

export function bindAsyncAction(actionCreator, worker) {
  function* boundAsyncActionSaga(params, context) {
    yield put(actionCreator.started(params));
    let result;
    let isCancelled = false;
    try {
      result = yield call(worker, params, context);
    } catch (error) {
      yield put(actionCreator.failed({ params, error }));
      throw error;
    } finally {
      if (yield cancelled()) {
        isCancelled = true;
        yield put(actionCreator.failed({ params, error: 'cancelled' }));
      }
    }
    if (!isCancelled) yield put(actionCreator.done({ params, result }));
    return result;
  }
  return boundAsyncActionSaga;
}

export function* cycleLoad(params) {
  const action = yield call(apiRequest, _.merge(params, {
    params: {
      Skip: 0,
      Take: 50,
    },
  }));
  const ret = {
    data: action.data,
  };
  if (action.pagingInfo) {
    const currentOffset = action.cursorInfo ? action.cursorInfo.currentOffset : 50;
    let needRequest = true;

    while (needRequest) {
      const response = yield call(apiRequest, _.merge(params, {
        params: {
          Skip: currentOffset,
        },
      }));
      ret.data = [...ret.data, ...response.data];
      needRequest = response.cursorInfo.itemsLeft > 0;
    }
  } else {
    return ret;
  }

  return ret;
}



// WEBPACK FOOTER //
// ./src/utils/sagas.js